import { useLocation } from "react-router";
import TitleHeading from "../components/TitleHeading";
import { getLanguage } from "../helpers/storageHelper";
import { useTranslation } from "react-i18next";
import React from "react";
import { useSearchParams } from "react-router-dom";
import { getNewsById } from "../helpers/Api/apiHelper";
import LoadingScreen from "../components/LoadingScreen";
import MultilineContent from "../components/MultilineContent";

function NewsDetails() {
    const {state} = useLocation();
    const language = getLanguage();
    const [searchParams] = useSearchParams();
    const id = searchParams.get('id')
    const {t} = useTranslation();
    const [newsData, setNewsData] = React.useState(null);
    const [loading, setLoading] = React.useState(true);
    const data = state ?? newsData;
    React.useEffect(() => {
        if(!state && id) {
            const getNews = async (id) => {
                const response = await getNewsById(id)
                if(response) {
                    if(response.success) {
                        setNewsData(response.success);
                        setLoading(false);
                    }
                    else {
                        setNewsData(null);
                        setLoading(false);
                    }
                }
                else {
                    setNewsData(null);
                    setLoading(false);
                }
            }
            getNews(id);
        }
        else {
            setLoading(false)
        }
    },[])

    if(loading) return (<LoadingScreen />)

    if(data) {
        return (
            <section className="portfolio-block project p-0">
                <TitleHeading
                btnBackHref = "/news"
                title = {language == 1 ? data?.title : data?.enTitle}
                className = "text-center pt-4"
                />
                <div className="container">
                    <div className="img-container text-center mb-4">
                    <img src={data?.mainImageUrl} alt={data?.enTitle} className="images img-fluid mh-600" />
                    </div>
                    <div className="row">
                        <div className="col-12 col-md-6 offset-md-1 info">
                            <h3>{t("description")}</h3>
                            <p id="content">{MultilineContent(language == 1 ? data?.content : data?.enContent)}</p>
                        </div>
                        <div className="col-12 col-md-3 offset-md-1 meta">
                            <div className="tags">
                                {/* <span className="meta-heading">Tags</span>
                                <a href="#">Resource</a>
                                <a href="#">Project</a> */}
                                <span className="meta-heading">{t("date")}</span>
                                <span>{data?.date}</span>
                            </div>
                        </div>
                    </div>
                    <div className="more-projects">
                        <h3 className="text-center">{t("moreImage")}</h3>
                        <div className="row gallery">
                            {
                                data?.photoUrls && data?.photoUrls.map((item, index) => (
                                    <div className="col-md-4 col-lg-3 item" key={item?.id || index}>
                                        <div className="item m-0">
                                            <img className="img-fluid scale-on-hover" src={item?.url} alt="" />
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}
export default NewsDetails;